import { configureStore, AnyAction, ThunkAction } from '@reduxjs/toolkit';
import { baseApi } from '@api/baseApi';
import orderReducer from '@store/order/slice';
import catProbeReducer from '@store/cat-probe/slice';
import partnersRegistrationReducer from '@store/partners-registration/slice';
import partnersOrderReducer from '@store/partners-order/slice';



export const store = configureStore({
	reducer: {
		order: orderReducer,
		catProbe: catProbeReducer,
		partnersRegistration: partnersRegistrationReducer,
		partnersOrder: partnersOrderReducer,
		[baseApi.reducerPath]: baseApi.reducer,
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware()
		.concat(baseApi.middleware)
});



export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;


export const manualDispatch = (thunkAction: AnyAction | ThunkAction<unknown, any, any, AnyAction>) => store.dispatch(thunkAction);

export const getStore = () => store.getState();